import React, { useEffect } from 'react';
import useCollapsibleOverlay from '../../../hooks/useCollapsibleOverlay';
import { Tooltip, TooltipPlacement } from '../../../components/atoms/Tooltip';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Namespace } from '../../../translation/namespace';
import { Icons, SVG } from '../../../components/atoms/SVG';
import { BreadcrumbFlyout, BreadcrumbFlyoutProps } from './BreadcrumbFlyout';
import { CollapsibleContent } from '../../../components/organisms/CollapsibleOverlay/CollapsibleOverlay';
import { NavItem } from '../../../types/api/NavItem';

type SiblingsProps = { navItem: NavItem; index: number; siblings: BreadcrumbFlyoutProps };
export function Siblings({ index, siblings }: SiblingsProps) {
  const { t } = useSonTranslation(Namespace.Breadcrumb);
  const { collapsibleProps, toggleProps, collapsibleOpen, popperInstance } = useCollapsibleOverlay('bottom');

  useEffect(() => {
    if (collapsibleOpen && popperInstance) {
      popperInstance.update();
    }
  });

  return (
    <div className="breadcrumb__flyout-container">
      <Tooltip attachTo={toggleProps.ref} placement={TooltipPlacement.TOP} hideTooltipFromScreenReader>
        <button
          type="button"
          className="breadcrumb__button"
          title={t('furtherPagesText', { number: index })}
          {...toggleProps}
        >
          <span className="invisible">{t('furtherPagesText', { number: index })}</span>
          <SVG
            svgClass={collapsibleOpen ? undefined : 'breadcrumb__button-svg'}
            svgSpriteId={collapsibleOpen ? Icons.DELETE_X_SMALL : Icons.ARROW_DOWN}
          />
        </button>
      </Tooltip>
      <CollapsibleContent {...collapsibleProps}>
        <BreadcrumbFlyout groups={siblings.groups} />
      </CollapsibleContent>
    </div>
  );
}
